// @ vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CustomizedDot extends Component {

render () {
    const {
            cx,
            cy,
            payload
        } = this.props;
    if(!payload.dot){
        return null
    }
    return (<circle cx={cx - 0} cy={cy - 0} r={10} fill="#fbb800" id="circle"/>);
  }
}

CustomizedDot.propTypes = {
    cx: PropTypes.number,
    cy: PropTypes.number,
    payload: PropTypes.object
};

export default CustomizedDot;